/**
 * Uppercase the first letter of a string
 *
 * @param {string} [str=''] The string to capitalize
 * @returns {string} The capitalized string
 *
 * @note {@link str} is stringified internally before being used
 */
export const capitalize = (str = '') => {
	str = str == null ? '' : String(str);
	return str.charAt(0).toUpperCase().concat(str.slice(1));
};
